import React, { useMemo, useCallback } from "react";
import Avatar from "../../../../../components/Avatar";
import { Grid, Tooltip } from "@mui/material";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useCustomSearchParams } from "../../../../../hooks/useCustomSearchParams";
import { createAvtarName, hasImage } from "../../../../../utils";
import { useResponsive } from "../../../../../hooks/useResponsive";
import { useSearchParams } from "react-router-dom";

function FeedLabelHistory({ history, boardName }) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const boardKey = boardName?.data?.data?.responseData?.key;
  const [data, updateSearchParams] = useCustomSearchParams("card_id");
  const isMobile = useResponsive("down", "md");

  const userData = useMemo(() => ({
    username: history?.response_object?.user_object?.username || '',
    userImage: history?.response_object?.user_object?.user_image,
    profileColor: history?.response_object?.user_object?.user_profile_color,
  }), [history?.response_object?.user_object]);


  const boardData = useMemo(() => ({
    boardId: boardName?.data?.data?.responseData?.board_id,
    boardKey: boardName?.data?.data?.responseData?.key,
    boardName: boardName?.data?.data?.responseData?.board_name,
  }), [boardName?.data?.data?.responseData]);

  const avatarStyles = useMemo(() => (
    !hasImage(userData.userImage) ? {
      bgcolor: userData.profileColor?.background || "",
      color: userData.profileColor?.text,
    } : {}
  ), [userData.userImage, userData.profileColor]);

  const formattedDate = useMemo(() => (
    moment.utc(history?.at_time)
      .local()
      .format(isMobile ? "MMM D, YYYY [at] h:mm A" : "MMMM D, YYYY [at] h:mm A")
  ), [history?.at_time, isMobile]);

  const { epicData, labelData } = useMemo(() => ({
    epicData: {
      added: history?.response_object?.added_epic,
      removed: history?.response_object?.removed_epic,
    },
    labelData: {
      added: history?.response_object?.added_labels?.filter(label => label !== "") || [],
      removed: history?.response_object?.removed_labels?.filter(label => label !== "") || [],
    }
  }), [history?.response_object]);
  
  const openBoard = useCallback(() => {
    navigate(`/board/${boardData.boardId}`);
  }, [navigate, boardData.boardId]);
  const handleCardClick = useCallback((event) => {
    const isModifierPressed = event.metaKey || event.ctrlKey || event.shiftKey;
    const url = `/feeds/${boardKey}/${boardKey}-${history?.card_id}?${searchParams.toString()}`;
    if (isModifierPressed) {
      window.open(url, "_blank");
      event.stopPropagation();
      return;
    }
    navigate(url);
  }, [updateSearchParams, history?.card_id]);

  if (!history) return null;

  return (

        <Grid
          container
          spacing={2}
          sx={{
            width: isMobile
              ? "calc(100% - 10px) !important"
              : "calc(100% + 16px) !important",
          }}
          className="worklog-item d-flex justify-content-space-between">
          <Grid
            item
            xs={isMobile ? 12 : 9}
            sx={{ paddingLeft: isMobile && "8px !important" }}>
            <div className="d-flex w-100">
              <Avatar
                // key={`user-avtar-${el.user_id}`}
                username={`${history?.response_object?.user_object?.username}`}
                user_image={history?.response_object?.user_object?.user_image}
                title={`${history?.response_object?.user_object?.username}`}
                className="user-avtar-dropdown user-avatar mr-8"
                style={avatarStyles}>
                    {createAvtarName(userData.username)}  
              </Avatar>
              <div className="w-100">
                <div className="d-flex justify-content-space-between ">
                  <div className={"d-flex align-items-center"}>
                    <div>
                      <Tooltip title={"ABC"}>
                        <a
                          className="board-anquor cursor-pointer underline"
                          onClick={openBoard}>
                               {boardData.boardKey?.toUpperCase()}
                        </a>
                      </Tooltip>
                      -
                      <a
                        className="board-anquor cursor-pointer mr-1 underline"
                        onClick={handleCardClick}>
                        {history?.card_id}:
                      </a>
                    </div>
                    <p className="worklog-title mr-2">
                    {userData.username}
                    </p>
                    {epicData.added && (
                      <div className="card-epic-tag mr-1">
                        <p className="card-epic-tag-text">{epicData.added}</p>
                      </div>
                    )}
                    {epicData.removed && (
                      <div className="card-epic-tag mr-1">
                        <p className="card-epic-tag-text">{epicData.removed}</p>
                      </div>
                    )}
                    {
                      <div className="d-flex">
                        {labelData.added.map((label, index) => (
                    <div className="card-level-tag mr-1" key={`added-${label}-${index}`}>
                      <p className="card-level-tag-text">{label}</p>
                    </div>
                  ))}
                      {labelData.removed.map((label, index) => (
                    <div className="card-level-tag mr-1" key={`removed-${label}-${index}`}>
                      <p className="card-level-tag-text">{label}</p>
                    </div>
                  ))}
                      </div>
                    }
                  </div>
                  {/* <p className="hours">{worklog.hours_spent} Hour</p> */}
                </div>
                <p
                  className="worklog-worklog comment-content"
                  dangerouslySetInnerHTML={{
                    __html: history?.history_text,
                  }}></p>
              </div>
            </div>
          </Grid>
          <Grid
            item
            xs={isMobile ? 12 : 3}
            sx={{ paddingTop: isMobile && "0px !important" }}>
            <div className={"right-details d-flex"}>
              <p className="worklog-date-time comment-date comment">
                Updated on{" "}
              </p>
              <p className="worklog-date-time comment-date">
                {/* {!sameDay && <img src={lateIcon} className="late-icon" />} */}

                {formattedDate}
              </p>
            </div>
          </Grid>
        </Grid>
     
  );
}

export default FeedLabelHistory;
